<div class="background">
    <h4>{{ data }}</h4>
    <mat-dialog-actions>
        <button mat-button [mat-dialog-close]="true" cdkFocusInitial>Ok</button>
    </mat-dialog-actions>
</div>
